import { render, staticRenderFns } from "./SinglePurchaseStockings.vue?vue&type=template&id=1dbc5418&"
import script from "./SinglePurchaseStockings.vue?vue&type=script&lang=js&"
export * from "./SinglePurchaseStockings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SinglePurchaseStockings.vue"
export default component.exports